import { render } from "./About.vue?vue&type=template&id=f7d7e4d8"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import exportComponent from "/builds/optelgroup/exploration/reusable-components/supply-chain-simulator/prototype/iscp-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__